import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  ListSubheader,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { CiImport, CiExport } from "react-icons/ci";
// import SearchBar from "../../SearchBar";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { MoreVert } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Loader from "../../components/common/Loader";
import dayjs from "dayjs";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import { useFetchIssueModuleQuery,} from "../../slice/logdetailSlice";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CommonDeleteDialog from "../../components/common/CommonDelete";
import SearchBar from "../../components/SearchBar";
// import Loader from "../../components/common/Loader";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { CommonAddIssue } from "../../components/common/Issue/CommonAddIssue";
import ImportTimesheet from "../../components/common/TimesheetImport";
import { usePersistentFilter } from "../../assets/hooks/usePersistentFilter";
import CommonTaskIssueNameChamge from "../../components/common/CommonTaskIssueNameChamge";
import { useTheme } from "../../ThemeContext";
import { CommonIssueExport } from "../../components/common/Issue/CommonIssueExport";
import IssueBoard from "../../components/ProjectModule/issues/IssueBoard";
import { openInNewTab } from "../../utils/openInNewTab";

const Issues = () => {
  const { isDarkMode } = useTheme();
  const [viewMode, setViewMode] = usePersistentFilter("globalIssueViewMode", "list");
  const [loading, setLoading] = useState(false);
  const [Milestone, setMilestone] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [boardSearchTerm, setBoardSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [checkedMilestones, setCheckedMilestones] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [checkedRows, setCheckedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  const [selectedTask, setSelectedTask] = useState(null);
  const { name, id: login_user_id, role: login_user_role } = loginUser;
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [clearFilter, setClearFilter] = useState(false);
  const navigate = useNavigate();
  const [filter, setFilter] = usePersistentFilter(
    "issuemodulefilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6
  );
  const ProjectID = localStorage.getItem("project_id");
  // ////console.log()("login_user_detail in redux state: ", loginUser);
  const { reset } = useForm();
  const [menuOpen, setMenuOpen] = useState(null);
  const open = Boolean(menuOpen);
  const {
    data: issue_module,
    refetch: issue_module_refetch,
    isLoading: issue_module_loading,
  } = useFetchIssueModuleQuery({
    view_type_id: filter,
    searchText: viewMode === "list" ? searchTerm : "",
  });
  // ////console.log()("module_response issue_module:", issue_module);
  // const numericId =
  //   parseInt(selectedTask?.id.replace(/\D/g, ""), 10) || selectedTask?.id;
  const toggleRow = (projectId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  const boardIssues = React.useMemo(() => {
    let flattened = [];
    issue_module?.forEach((item) => {
      if (item.issues && item.issues.length) {
        item.issues.forEach(issue => {
           flattened.push({
             ...issue,
             id: issue.issue_id || issue.id,
           });
        });
      }
    });
    return flattened;
  }, [issue_module]);

  // Handle checkbox selection
  const handleCheckboxChange = (event, row) => {
    event.stopPropagation();
    setCheckedRows((prev) => ({
      ...prev,
      [row.id]: event.target.checked,
    }));
  };

  // Open menu
  const handleMenuOpen = (event, row) => {
    // ////console.log()("event_names :", row);

    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask({
      id: row.issue_id,
      name: row.title,
      project_id: row.parent_id,
    });
  };

  // Close menu
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  // Handle menu item click
  const handleMenuClick = (value) => {
    if (selectedTask) {
      // ////console.log()(
      //   `Task ID: ${selectedTask.id}, Task Name: ${selectedTask.name}`
      // );
      // ////console.log()("project_id_in_issue :", selectedTask.project_id);
      localStorage.setItem("project_id", selectedTask.project_id);
      if (value === true) {
        navigate(
          `/projects/projectDetail/${selectedTask.project_id}/issue/IssueDetail/${selectedTask.id}`
        );
      } else {
        const path = `/projects/projectDetail/${selectedTask.project_id}/issue/IssueDetail/${selectedTask.id}`;
        openInNewTab(path);
      }
    }
    handleMenuClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedSubtask(null);
  };


  const rows = [];

  issue_module?.forEach((item) => {
    const project = item.project;
    const issues = item.issues;

    // Add parent project row
    rows.push({
      id: `P-ID-${project.project_id}`,
      project_id: project.project_id,
      name: project.title,
      isParent: true, // Flag for parent row
    });

    // Add child issue rows if expanded
    if (expandedRows[project.project_id] && issues?.length) {
      issues.forEach((issue) => {
        rows.push({
          id: `I-ID-${issue.issue_id}`,
          parent_id: project.project_id,
          issue_id: issue.issue_id,
          title: issue.title,
          priority_name: issue.priority_name,
          severity_name: issue.severity_name,
          current_status_name: issue.current_status_name,
          assignee_name: issue.assignee_name,
          reporter_name: issue.reporter_name,
          module: issue.module,
          priority_colour: issue.priority_colour,
          severity_colour: issue.severity_colour,
          status_colour: issue.status_colour,
          added_at: issue.added_at,
          updated_at: issue.updated_at,
          updated_name: issue.updated_name,
          due_date: issue.due_date,
          isParent: false, // Mark as child row
        });
      });
    }
  });
  useEffect(() => {
    issue_module_refetch();
  }, []);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {/* Parent Dropdown Icon */}
          {params.row.isParent && (
            <IconButton
              size="small"
              onClick={() => toggleRow(params.row.project_id)}
            >
              {expandedRows[params.row.project_id] ? (
                <ExpandMoreIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          )}

          {/* Checkbox and MoreHorizIcon for Child Rows */}
          {!params.row.isParent && (
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={!!checkedRows[params.row.id]}
                onChange={(event) => handleCheckboxChange(event, params.row)}
              />
              {checkedRows[params.row.id] && (
                <IconButton
                  onClick={(event) => handleMenuOpen(event, params.row)}
                >
                  <MoreHorizIcon />
                </IconButton>
              )}
            </Box>
          )}
        </Box>
      ),
    },
    { field: "id", headerName: "ID", width: 100 },
   
    {
      field: "name",
      headerName: "Name",
      width: 250,
      renderCell: (params) => {
        const handleClick = () => {
          if (!params.row.isParent) {
            // const issueNumber = params.row.id.replace(/\D/g, ""); // Extract only numbers
            navigate(
              `/projects/projectDetail/${params.row.parent_id}/issue/IssueDetail/${params.row.issue_id}`
            );
          }
        };
        return (
          <Box
            sx={{
              fontWeight: params.row.isParent ? "600" : "normal",
              cursor: !params.row.isParent ? "pointer" : "default",
            }}
            onClick={handleClick}
          >
            {params.row.isParent ? params.row.name : params.row.title}
          </Box>
        );
      },
    },
     {
      field: "module",
      headerName: "Module",
      width: 180,
      renderCell: (params) =>
        params.row.module ? (
          <Box
            sx={{
              // color: params.row.status_colour || "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.row.module}
          </Box>
        ) : (
          ""
        ),
    },
    {
      field: "owner_name",
      headerName: "Reporter",
      width: 180,
      renderCell: (params) =>
        params.row.isParent
          ? params.row.owner_name
          : params.row.reporter_name || "Unassigned",
    },
    {
      field: "assignee_name",
      headerName: "Assignee",
      width: 180,
      renderCell: (params) =>
        params.row.isParent
          ? params.row.assignee_name
          : params.row.assignee_name || "Unassigned",
    },
    {
      field: "due_date",
      headerName: "Due Date",
      width: 150,
      renderCell: (params) => {
        if (params.row.isParent || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY") : params.value}
          </Box>
        );
      },
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) =>
        params.row.current_status_name ? (
          <Box
            sx={{
              color: params.row.status_colour || "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.row.current_status_name}
          </Box>
        ) : (
          ""
        ),
    },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) =>
        !params.row.isParent ? (
          <Box sx={{ color: params.row.priority_colour || "black" }}>
            {params.row.priority_name}
          </Box>
        ) : (
          ""
        ),
    },
    {
      field: "severity_name",
      headerName: "Severity",
      width: 150,
      renderCell: (params) =>
        !params.row.isParent ? (
          <Box sx={{ color: params.row.severity_colour || "black" }}>
            {params.row.severity_name}
          </Box>
        ) : (
          ""
        ),
    },
    {
      field: "reporter_name",
      headerName: "Created By",
      width: 180,
      renderCell: (params) =>
        params.row.isParent
          ? params.row.owner_name
          : params.row.reporter_name || "Unassigned",
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (params.row.isParent || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        if (params.row.isParent) return null;
        return (
          <Box>
            {params.value || "-"}
          </Box>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (params.row.isParent || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
  ];

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter
  const handleShowImport = () => {
    setShowImport(true); // Open filter
    handleCloseMenu();
  };
  const handleCloseMenu = () => {
    setMenuOpen(null);
  };
  const handleOpenMenu = (event) => {
    setMenuOpen(event.currentTarget);
  };
  const handleImport = () => {
    reset();
  };
  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };
  const filterOptions = {
    predefined: [
      { label: "All Issue", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Re Open", value: 11 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned", value: 5 },
      // { label: "Unscheduled Tasks", value: "unscheduled" },
      // { label: "Closed Task Lists", value: "closed_task_lists" },
    ],
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Re Open", value: 12 },
      { label: "My Closed", value: 7 },
      // { label: "My Overdue & Open", value: "my_overdue_open" },
      { label: "Today's Issue", value: 8 },
      { label: "Issue I Follow", value: 9 },
      { label: "Issue Created By Me", value: 10 },
      // { label: "Assigned Via Pick List", value: "assigned_via_pick_list" },
    ],
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    let filteredProjects;
    switch (value) {
      case "completed":
        filteredProjects = Milestone.filter(
          (project) => project.completion === 100
        );

        break;
      case "recent":
        filteredProjects = Milestone; // Modify this to sort/filter based on recent access logic
        break;
      default:
        filteredProjects = Milestone;
    }

    setMilestone(filteredProjects);
  };
  const handleApplyFilter = (filteredData) => {
    setMilestone(
      // filteredData.map((project) => ({
      //   ...project,
      //   id: project.milestone_id, // Ensure DataGrid has a unique ID
      // }))
      filteredData.map((project) => ({
        ...project,
        id: project.task_id,
      }))
    );

    setShowFilter(false);
    setClearFilter(true);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    // if (value) {
    //   await fetchSearchedMilestone(value);
    // } else {
    //   await fetchMilestone();
    //   // setIssues([]); // Clear projects if search term is empty
    // }
  };


  return (
    <>
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddIssueComponent
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            Issues={Issues}
            fetchIssues={issue_module_refetch}
          /> */}
          <CommonAddIssue
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            // Issues={Issues}
            fetchIssues={issue_module_refetch}
            path="issue"
            isModule={true}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>
      <Offcanvas
        show={showImport}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddIssueComponent
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            Issues={Issues}
            fetchIssues={issue_module_refetch}
          /> */}
          <ImportTimesheet
            // onClear={() => reset()} // Resets to initial values
            // onCancel={() => setShowImport(false)}
            // Issues={Issues}
            // fetchIssues={issue_module_refetch}
            onCancel={() => setShowImport(false)}
            refetchList={issue_module_refetch}
            isModule={true}
            onDocumentAdded={handleImport}
            importPath="importIssues"
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>
      <Offcanvas
        show={showExport}
        onHide={() => setShowExport(false)}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <CommonIssueExport
            onCancel={() => setShowExport(false)}
            refetchList={issue_module_refetch}
            IssuesList={issue_module}
            isModule={true}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <div style={{ height: "100%", width: "100%" }} className="bg-white p-3">
        {/* <div className="d-flex justify-content-between pb-2">
          <FormControl className="pb-2"> */}
            {/* {login_user_role !== "EMPLOYEE" ? (
              <Select value={filter} onChange={handleFilterChange} displayEmpty>
                <label className="text-rgba-gray ps-3">Predefined Views</label>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            ) : ( */}


        <Box
          className="d-flex align-items-center justify-content-between gap-3"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <FormControl>
              <Select
                value={filter}
                onChange={handleFilterChange}
                displayEmpty
                className="AddButtonIssues"
              >
                {/* <label className="text-rgba-gray ps-3">Predefined Views</label> */}
                  <ListSubheader
                  className="text-rgba-gray ps-3"
                  style={{ backgroundColor: "aliceblue" }}
                >
                  Predefined Views
                </ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}

                {/* <label className="text-rgba-gray ps-3">My Views</label> */}
                <ListSubheader
                  className="text-rgba-gray ps-3"
                  style={{ backgroundColor: "aliceblue" }}
                >
                  My Views
                </ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {/* )} */}
            </FormControl>

            {login_user_role !== "CLIENT" && (
              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <Tooltip title="Table View">
                  <IconButton
                    onClick={() => setViewMode("list")}
                    sx={{
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                      color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                      border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                      borderRadius: "4px",
                      height: "34px",
                      width: "75px",
                      gap: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <CiViewList size={18} />
                    Table
                  </IconButton>
                </Tooltip>

                <Tooltip title="Board View">
                  <IconButton
                    onClick={() => setViewMode("board")}
                    sx={{
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                      color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                      border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                      borderRadius: "4px",
                      height: "34px",
                      width: "75px",
                      gap: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <MdViewQuilt size={18} />
                    Board
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>

          <div className="d-flex align-items-center gap-3">
            <SearchBar
              placeholder="Search issue"
              searchTerm={viewMode === "board" ? boardSearchTerm : searchTerm}
              onSearchChange={(e) => {
                if (viewMode === "board") {
                  setBoardSearchTerm(e?.target?.value || "");
                } else {
                  handleSearchChange(e);
                }
              }}
            />
            {clearFilter && (
              <button
                type="button"
                className="addmore_btn"
                onClick={issue_module_refetch}
              >
                Clear filter
              </button>
            )}
            {login_user_role !== "CLIENT" && (
              // <button className="AddButton" onClick={handleShowProject}>
              //   {/* <CiCirclePlus className="text-rgbr-blue pro-icon-s" /> */}
              //   Add Issue
              // </button>

              <Button
                className="rounded AddButton me-2"
                onClick={handleShowProject}
              >
                Add Issue
              </Button>
            )}

            <Tooltip title="More Options">
              <IconButton
                onClick={handleOpenMenu}
                sx={{
                  backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                  borderRadius: "50%",
                  width: "38px",
                  height: "38px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
              >
                <MoreVert sx={{ color: "rgba(18, 183, 159, 1)", fontSize: 23 }} />
              </IconButton>
            </Tooltip>

            
            <Menu
              anchorEl={menuOpen}
              open={open}
              onClose={handleCloseMenu}
              PaperProps={{
                sx: {
                  backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
                  color: isDarkMode ? "#fff" : "inherit",
                  boxShadow: isDarkMode ? "0px 5px 15px rgba(0,0,0,0.5)" : "0px 5px 15px rgba(0,0,0,0.1)",
                }
              }}
            >
              
              <MenuItem>
                {login_user_role !== "CLIENT" && (
                  <button
                    onClick={handleShowImport}
                    className="border-0 bg-transparent text-decoration-none d-flex align-items-center p-2"
                  >
                    <CiImport className="text-rgbr-blue pro-icon-s" size={20} />
                    <span className={isDarkMode ? "text-white ms-2" : "text-dark ms-2"}>Import</span>
                  </button>
                )}
              </MenuItem>
              <MenuItem>
                <button
                  onClick={() => {
                    setShowExport(true);
                    handleCloseMenu();
                  }}
                  className="border-0 bg-transparent text-decoration-none d-flex align-items-center p-2"
                >
                  <CiExport className="text-rgbr-blue pro-icon-s" size={20} />
                  <span className={isDarkMode ? "text-white ms-2" : "text-dark ms-2"}>Export</span>
                </button>
              </MenuItem>
            </Menu>
          
          </div>
        </Box>

        {issue_module_loading ? (
          <Loader /> // Display loader while loading
        ) : viewMode === "board" ? (
          <IssueBoard
            ProjectID={ProjectID}
            allIssues={boardIssues}
            onRefresh={issue_module_refetch}
            loading={issue_module_loading}
            searchTerm={boardSearchTerm}
          />
        ) : (
          <Box
            style={{
              // height: Milestone.length === 0 ? 300 : "auto",
              width: "100%",
            }}
          >
            <Box style={{ minHeight: 300, width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                pagination
                disableColumnMenu
                disableColumnSorting
                disableColumnFilter
                disableColumnSelector
                pageSizeOptions={[10, 20, 30, 40]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                disableSelectionOnClick
                autoHeight
              />
            </Box>

            {/* Menu for Action Button Options */}
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleMenuClick(true)}>
                <CiViewList className="me-2" color="blue" />
                View Details
              </MenuItem>
              <MenuItem onClick={() => handleMenuClick(false)}>
                <CiViewList className="me-2" color="blue" />
                View Details in New Tab
              </MenuItem>
              <CommonDeleteDialog
                name="Issue"
                statusName={selectedTask?.name}
                id={selectedTask?.id}
                url="issue/delete"
                refetchList={issue_module_refetch}
                handleListClose={handleMenuClose}
              />
              <CommonTaskIssueNameChamge
                name="Issue"
                path="issue/update"
                selectedTask={selectedTask}
                setMenuAnchorEl={setMenuAnchorEl}
                refetch_list={issue_module_refetch}
              />
            </Menu>
          </Box>
        )}
      </div>
    </>
  );
};
export default Issues;
